import { Button, Stack, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";

import { CountrySelect } from "./CountrySelect";

interface Props {
  routePointLocation: RoutePointLocation;
  handleRoutePointLocationValueChange: <T>(
    key: keyof RoutePointLocation,
    value: T | null,
  ) => void;
  updateInputModeForRoutePoint: (mode: "autocomplete" | "manual") => void;
}

export function ManualRoutePointInput(props: Props) {
  const {
    routePointLocation,
    handleRoutePointLocationValueChange,
    updateInputModeForRoutePoint,
  } = props;

  return (
    <Stack direction="column">
      <form>
        <TextField
          fullWidth
          label="Business Name"
          variant="outlined"
          placeholder="Acme Supply Co."
          value={routePointLocation.business_name}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            handleRoutePointLocationValueChange(
              "business_name",
              event.target.value,
            );
          }}
        />
        <TextField
          fullWidth
          sx={{ mt: ".5rem" }}
          label="Street Address"
          variant="outlined"
          value={routePointLocation.address}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            handleRoutePointLocationValueChange("address", event.target.value);
          }}
        />
        <Stack
          direction="row"
          spacing={1}
          sx={{ mt: ".5rem" }}
          alignContent="space-between"
        >
          <TextField
            sx={{ width: "60%" }}
            label="City"
            variant="outlined"
            required
            value={routePointLocation.city}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              handleRoutePointLocationValueChange("city", event.target.value);
            }}
          />
          <TextField
            sx={{ width: "40%" }}
            label="Province/State (Ex. NY)"
            variant="outlined"
            required
            placeholder="Example: NY"
            value={routePointLocation.province}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              handleRoutePointLocationValueChange(
                "province",
                event.target.value,
              );
            }}
          />
        </Stack>
        <Stack direction="row" spacing={1} sx={{ mt: ".5rem" }}>
          <Box sx={{ width: "60%" }}>
            <CountrySelect
              value={routePointLocation.country}
              onChange={(selection: string) => {
                handleRoutePointLocationValueChange("country", selection);
              }}
            />
          </Box>

          <TextField
            sx={{ width: "40%" }}
            label="Postal Code"
            variant="outlined"
            value={routePointLocation.postal}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              handleRoutePointLocationValueChange("postal", event.target.value);
            }}
          />
        </Stack>
        <Stack alignItems="baseline" direction="row" mt=".5rem" spacing={2}>
          <Typography variant="body2" color="text.secondary">
            Don&apos;t want to type?{" "}
            <Button
              onClick={() => updateInputModeForRoutePoint("autocomplete")}
              variant="text"
              color="primary"
              sx={{
                textTransform: "none",
                padding: 0,
                minWidth: "unset",
                fontSize: "inherit",
                lineHeight: "inherit",
                verticalAlign: "baseline",
              }}
            >
              Switch to autocomplete mode.
            </Button>
          </Typography>
        </Stack>
      </form>
    </Stack>
  );
}
